import { Entry } from 'contentful'

import { IViewDemosMultiStepForm as IContentfulViewDemosMultiStepForm } from 'marketing-site/@types/generated/contentful'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import {
  IProps as IViewDemosMultiStepForm,
  ViewDemosMultiStepForm,
} from 'marketing-site/src/library/components/ViewDemosMultiStepForm'
import React from 'react'
import { transformMarketoFormV2 } from './ContentfulMarketoForm'

export const ContentfulViewDemosMultiStepForm = (
  viewDemosMultiStepForm: IContentfulViewDemosMultiStepForm,
): React.ReactElement => (
  <EntryMarker entry={viewDemosMultiStepForm}>
    {() => <ViewDemosMultiStepForm {...transformViewDemosMultiStepForm(viewDemosMultiStepForm)} />}
  </EntryMarker>
)

export function isViewDemosMultiStepForm(
  entry: Entry<any>,
): entry is IContentfulViewDemosMultiStepForm {
  return entry.sys.contentType?.sys.id === 'viewDemosMultiStepForm'
}

export function transformViewDemosMultiStepForm({
  fields,
}: IContentfulViewDemosMultiStepForm): IViewDemosMultiStepForm {
  return {
    ...fields,
    marketoProps: transformMarketoFormV2(fields.marketoForm.fields),
    submitButtonLabels: fields.submitButtonLabels,
  }
}
